import { ErrorInfo, ReactNode } from 'react';
import { ErrorBoundaryInner } from '@/components/ErrorBoundaryInner';

interface Props {
  children: ReactNode;
}

function ErrorBoundary({ children }: Props) {
  const handleError = (error: Error, errorInfo: ErrorInfo) => {
    console.error('Erro capturado pelo ErrorBoundary:', error, errorInfo);
  };

  return (
    <ErrorBoundaryInner onError={handleError}>
      {children}
    </ErrorBoundaryInner>
  );
}

export default ErrorBoundary;
